import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import { colors } from "../../common/theme";

export const HeaderSection = styled("header")`
  /* 左右不加内边距，让 logo 与正文共用 Container 的对齐基线 */
  padding: 1.25rem 0;
`;

export const HeaderInner = styled("div")`
  display: flex;
  align-items: center;
`;

export const LogoContainer = styled(Link)`
  display: flex;
  flex-shrink: 0;
  align-items: center;
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

/* 主导航紧跟 logo，剩余空间由 margin-right: auto 吸收，把 CTA 推到最右 */
export const DesktopNav = styled("nav")`
  display: flex;
  margin-left: 3rem;
  margin-right: auto;
  align-items: center;

  @media only screen and (min-width: 891px) and (max-width: 1120px) {
    margin-left: 1.75rem;
  }

  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const DesktopCta = styled("div")`
  display: flex;
  flex-shrink: 0;
  align-items: center;

  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Burger = styled("div")`
  display: none;

  @media only screen and (max-width: 890px) {
    display: block;
    margin-left: auto;
  }

  svg {
    fill: ${colors.primary};
  }
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  flex-shrink: 0;
  margin: 0 1.1rem;
  color: ${colors.heading};
  font-size: 1.15rem;
  white-space: nowrap;
  transition: color 0.2s ease-in;

  &:first-child {
    margin-left: 0;
  }

  /* 中等宽度下收紧间距，避免挤压 */
  @media only screen and (min-width: 891px) and (max-width: 1120px) {
    margin: 0 0.6rem;
    font-size: 1.05rem;
  }

  /* 890px 以下桌面导航隐藏，这里的间距只作用于抽屉菜单 */
  @media only screen and (max-width: 890px) {
    margin: 1.25rem 2rem;
    white-space: normal;
  }
`;

export const ContactNavItem = styled(CustomNavLinkSmall)`
  width: 160px;
  margin: 0;

  @media only screen and (min-width: 891px) and (max-width: 1120px) {
    width: 138px;
  }

  @media only screen and (max-width: 890px) {
    width: auto;
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled("span")`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  color: #404041;
  font-weight: 500;
  text-align: right;
`;

export const Outline = styled(MenuOutlined)<any>`
  font-size: 22px;
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    /* 白底上用较深的蓝，logo 天蓝作文字对比度不足 */
    color: ${colors.accentText};
    text-underline-position: under;
    text-decoration: ${colors.accent} wavy underline;
  }
`;
